module.exports = __webpack_public_path__ + "static/media/i-am-that-i-am.332ecf33.txt";